module.exports = __webpack_public_path__ + "static/002_gan-529a0fc2bdba88ea1d388df745eaa464.jpg";